import { css } from '@emotion/react';
import { isWeaveUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { breakpoints } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { SpinningLoader } from '@frontend/design-system';
import { DecoratedLocationPicker } from '../location-picker';

export const LocationPickerPage = () => {
  const { t } = useTranslation('locations');
  const { scopeHierarchy } = useAppScopeStore();
  const scopeLocationDataProcessed = isWeaveUser() || !!Object.keys(scopeHierarchy).length;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(1),
      }}
    >
      {scopeLocationDataProcessed ? (
        <Page
          maxWidth={600}
          css={[
            css({
              border: `1px solid ${theme.colors.neutral20}`,
              borderRadius: theme.borderRadius.small,
              padding: theme.spacing(3, 1),
              height: 'calc(100vh - 100px);',
              overflow: 'hidden',
            }),
            css`
               @media (max-width: ${breakpoints.small.max}px) {
      padding: ${theme.spacing(1)};
    }

            .page-header {
              padding: ${theme.spacing(3, 2, 1, 2)};
          `,
          ]}
        >
          <Page.Header css={{ padding: theme.spacing(3) }}>
            <Page.Header.Title title={t('Office Locations')} />
            <Page.Header.Subtitle subtitle={t('Manage multiple offices with ease.')} />
          </Page.Header>
          <DecoratedLocationPicker simple />
        </Page>
      ) : (
        <div css={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <SpinningLoader color='default' />
        </div>
      )}
    </div>
  );
};
